export default __webpack_public_path__ + "static/media/screen7.93904694.png";